import styled from '@emotion/styled';

export default styled.button`
	font-size: 100%;
	font-family: inherit;
	border: 0;
	padding: 0;
	background: none;
	cursor: pointer;

	&:focus {
		outline: 0;
	}
`;
